export type PatientActivityFilterType = {
  fromDate: string;
  toDate: string;
};

export enum PatientActivityFilterReducerActions {
  UPDATE_ALL_FILTER,
  UPDATE_FROM_DATE,
  UPDATE_TO_DATE,
}
export const defaultActivityFilterState: PatientActivityFilterType = {
  fromDate: null,
  toDate: null,
};
export const OBSERVATION_GOAL_ACTIVITY_TYPE = 'OBSERVATION_GOAL';
